module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [(_vm.image) ? _c('div', {
    staticClass: "card-image"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "alt": _vm.key
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content markdown"
  }, [(!_vm.done) ? _c('loader') : _vm._e(), _vm._v(" "), (_vm.done) ? _c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.done) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2070f088!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/component/MarkdownCard.vue
// module id = 73
// module chunks = 0